import axiosInstance from '../axiosConfig';
// src/api/hooks/usePostData.js
import { useState } from 'react';

const usePostData = (endpoint) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const postData = async (data, formData = false) => {
        setLoading(true);
        try {
            const response = formData ? 
                await axiosInstance.post(endpoint, data,  { headers: { 'Content-Type': 'multipart/form-data' } }) : 
                await axiosInstance.post(endpoint, data);
            return response.data;
        } catch (err) {
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { postData, loading, error };
};

export default usePostData;
